class EditButton {

    constructor($compile) {

        this.$compile = $compile;
        this.editMarkup = "<div class='rename-editor'><input type='text'><i class='fa fa-close' aria-hidden='true'></i><i class='fa fa-check' aria-hidden='true'></i></div>";
        this.isShowing = false;

        return {
            restrict: 'E',
            template: '<i class="fa fa-edit"> </i>',
            scope: {
                editItem: "=",
                editFn: "&"
            },
            link: ($scope, $el, $attr) => {

                $el.parent().mouseover( () => {
                    $el.css("visibility", "visible");
                });

                $el.parent().mouseleave( () => {
                    $el.css("visibility", "hidden");
                });
                
                $el.click( () => {
                    if(!$scope.isShowing) {
                        this.showEdit($el, $scope);
                    }
                });

            }
        };

    }

    showEdit($el, $scope) {

        $scope.shouldBlur = true;
        
        $el.css("display", "none");
        $("a", $el.parent()).css("display", "none");
        
        $el.parent().append(this.editMarkup);

        $("div.rename-editor > input", $el.parent()).focus();
        $("div.rename-editor > input", $el.parent()).val($scope.editItem);


        $("div.rename-editor > input", $el.parent()).keydown((ev) => {

            if(ev.keyCode === 13) { //enter key
                var name = $("div.rename-editor > input", $el.parent()).val();
                this.completeEdit($el, $scope, name);
            }
            else if(ev.keyCode === 27) { //esc key
                this.hideEdit($el, $scope);
            }
        });

        $("div.rename-editor > input", $el.parent()).blur( (ev) => {
            if($scope.shouldBlur) {
                this.hideEdit($el, $scope)
            } 
        });

        /*  The on blur event is bound before the click event so set a 
            flag on the mousedown event to stop edit being hidden on click */
        $("i.fa-check", $el.parent()).mousedown(() => {
            $scope.shouldBlur = false;
        });

        $("i.fa-check", $el.parent()).click(() => {
            var name = $("div.rename-editor > input", $el.parent()).val();
            this.completeEdit($el, $scope, name);
        });

        $("i.fa-close", $el.parent()).click(() => {
            this.hideEdit($el, $scope);
        });
        
        $scope.isShowing = true;

    }

    hideEdit($el, $scope) {
        $el.css("display", "inline-block");
        $("a", $el.parent()).css("display", "inline");
        $("div.rename-editor", $el.parent()).remove();
        $scope.isShowing = false;
    }

    completeEdit($el, $scope, name) {
        $scope.editItem = name;
        $scope.$apply();
        $scope.editFn($el, $scope);
        this.hideEdit($el, $scope);
    }

}


angular.module('cpm')
    .directive('editButton', ['$compile', ($compile) => {
        'use strict';
        return new EditButton($compile);
    }]);
